import request from '@/utils/request'

import { ResponseData, ResponseDataList, Search, CURD } from '../schemas'



export const getList = (data: Search): Promise<ResponseDataList> => {
  return request({
    url: '/countries/search',
    method: 'post',
    data,
  })
}


export const doAdd = (data: CURD): Promise<ResponseData> => {
  return request({
    url: '/countries',
    method: 'post',
    data,
  })
}

export const doUpdate = (data: CURD): Promise<ResponseData> => {
  return request({
    url: `/countries`,
    method: 'put',
    data,
  })
}


export const doDelete = (data: CURD): Promise<ResponseData> => {
  return request({
    url: `/countries/${String(data.id)}`,
    method: 'delete',
  })
}
